import React from "react";
import {
  Typography,
  Stack,
  Card,
  Box,
  IconButton,
  Button,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import { formatNumber } from "../../utils/helpers";

const OrderCards = ({
  orders,
  hasMore,
  isLoadingMore,
  setPage,
  fetchOrders,
  handleCancelOrder,
  handleDeleteOrder,
  handleShowInvoiceModal,
  hasPermission,
}) => {
  return (
    <Stack spacing={2} sx={{ mt: 2 }}>
      {orders.length > 0 ? (
        orders.map((order) => (
          <Card
            key={order._id}
            sx={{
              p: 2,
              borderRadius: 2,
              boxShadow: 1,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography fontWeight={600}>Mã: {order.orderCode}</Typography>
            {order.status === "Cancelled" && (
              <Typography variant="body2" color="error" fontWeight={600}>
                Đã hủy
              </Typography>
            )}
            <Box>
              {order.items.map((item) => (
                <Typography key={item._id} variant="body2">
                  {item?.name} (SL: {item?.quantity})
                </Typography>
              ))}
            </Box>
            <Typography variant="body2">
              Khách hàng: {order?.customer?.name || ""}
            </Typography>
            <Typography variant="body2">
              Tổng tiền: {formatNumber(order.totalAmount)}₫
            </Typography>
            <Typography variant="body2">
              Đã thanh toán: {formatNumber(order.amountPaid)}₫
            </Typography>
            <Typography variant="body2">
              Thanh toán: {order.paymentMethod === "Cash" ? "Tiền mặt" : "Chuyển khoản"}
            </Typography>
            <Typography variant="body2">
              Ngày tạo:{" "}
              {new Date(order.createdAt).toLocaleTimeString("vi-VN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              }) +
                " " +
                new Date(order.createdAt).toLocaleDateString("vi-VN")}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              {hasPermission(["order:update"]) && (
                <IconButton
                  onClick={() => handleCancelOrder(order)}
                  color="warning"
                  size="small"
                  disabled={order.status === "Cancelled"}
                >
                  <CancelIcon />
                </IconButton>
              )}
              {hasPermission(["order:delete"]) && (
                <IconButton
                  onClick={() => handleDeleteOrder(order)}
                  color="error"
                  size="small"
                >
                  <DeleteIcon />
                </IconButton>
              )}
              <IconButton
                onClick={() => handleShowInvoiceModal(order)}
                color="info"
                size="small"
              >
                <PrintIcon />
              </IconButton>
            </Box>
          </Card>
        ))
      ) : (
        <Typography align="center" color="text.secondary">
          Không có đơn hàng nào.
        </Typography>
      )}
      {hasMore && (
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Button
            variant="outlined"
            onClick={() => {
              setPage((prev) => prev + 1);
              fetchOrders(true);
            }}
            disabled={isLoadingMore}
          >
            {isLoadingMore ? "Đang tải..." : "Tải thêm hóa đơn"}
          </Button>
        </Box>
      )}
    </Stack>
  );
};

export default OrderCards;
